<div class="preview-cart">
  <ng-container *ngIf="cartItems.length; else emptyCart">
    <div class="preview-cart--items">
      <div class="items-container">
        <div class="items-wrap">
          <app-cart-item
            *ngFor="let cartItem of cartItems"
            [cartItem]="cartItem"
            [ethereumPrice]="ethereumService.ethereumPrice"
            (removeHandler$)="removeItem($event)"
          ></app-cart-item>
        </div>
      </div>
    </div>

    <div class="total-container">
      <div class="cart-total">
        <div class="cart-total-text">Your Cart Total</div>
        <div class="cart-total-price">
          <div class="cart-price">
            <svg width="27" height="24" viewBox="0 0 27 24">
              <use href="#ethereum-icon" />
            </svg>
            <div class="ethereum-currency">
              <span class="eth-price">{{
                totalEtheriumPrice | number: "1.0-4"
              }}</span>
              <span class="usd">
                {{ totalUSDPrice | currency: "USD":"symbol":"1.0-4" }}
              </span>
            </div>
          </div>
        </div>
        <button
          class="cart-total-button"
          [disabled]="!cartItems?.length"
          (click)="handleCheckout()"
        >
          Checkout
        </button>
      </div>
      <button class="w-btn w-btn--primary add-btn" routerLink="/">
        Add Tiles
      </button>
    </div>
  </ng-container>
  <ng-template #emptyCart>
    <div class="preview-cart--empty">
      <div class="empty-content">
        <span class="empty-content--text"
          >Our shopping cart is currently empty.</span
        >
        <button class="w-btn w-btn--primary" routerLink="/">Add Tiles</button>
      </div>
    </div>
  </ng-template>
</div>
